import { Link } from 'react-router-dom';

export function SmsConsentCheckbox({ checked, onChange, testId }) {
  return (
    <label className="flex items-start gap-3 mb-6 cursor-pointer" data-testid={`${testId}-label`}>
      <input
        type="checkbox"
        name="sms_consent"
        checked={checked}
        onChange={onChange}
        data-testid={testId}
        className="mt-0.5 h-4 w-4 shrink-0 border border-black accent-yellow-400 cursor-pointer"
      />
      <span className="font-body text-xs leading-relaxed text-zinc-600">
        <span className="font-semibold text-zinc-800">Optional:</span> By checking this box, I agree to receive text messages from Evolution Electric regarding my service inquiries, appointment confirmations, reminders, and follow-ups. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for assistance. Consent is not required to purchase services. See our{' '}
        <Link to="/privacy-policy" className="underline hover:text-black" data-testid={`${testId}-privacy-link`}>Privacy Policy</Link>{' '}
        and{' '}
        <Link to="/terms" className="underline hover:text-black" data-testid={`${testId}-terms-link`}>Terms of Service</Link>.
      </span>
    </label>
  );
}
